"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoStyled = exports.LoadingStyled = exports.SpinnerStyled = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _const = require("../../const");

var _const2 = require("./const");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Loader = function Loader(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.815 43.995l-.683-.705-.676-.714C5.53 38.388 2.01 33.868.429 31.681a1.168 1.168 0 0 1 0-1.367l.29-.397c1.844-2.506 5.637-7.31 9.723-11.53l.372-.382c2.296-2.34 5.688-5.384 10.176-9.13a48.792 48.792 0 0 1 3.447-2.545c1.808-1.218 3.011-1.9 3.996-2.461C32.94 1.3 37.213 0 41.134 0c8.863 0 16.074 7.39 16.074 16.476a17.32 17.32 0 0 1-2.964 9.684c-1.731 2.58-4.029 4.127-5.302 4.844a15.684 15.684 0 0 1 5.307 4.84c1.935 2.84 2.96 6.188 2.96 9.68C57.208 54.609 49.996 62 41.133 62c-3.977 0-8.13-1.267-12.701-3.87a53.191 53.191 0 0 1-8.423-5.827c-4.006-3.374-7.072-6.143-9.195-8.308z",
    style: {
      transform: "translate(17.3px,1px)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.225 7.297l1.587 1.621.196.212c5.288 5.93 8.2 13.703 8.2 21.886 0 4.159-.738 8.201-2.194 12.016-1.327 3.478-3.194 6.625-5.555 9.366l-.422.48-.178.196-1.646 1.656a29.144 29.144 0 0 1-7.027 4.806c-4.513 2.21-9.17 2.434-9.742 2.452L0 61.99V0h15.446c6.216.308 12.088 2.878 16.779 7.297z",
    style: {
      transform: "translate(8px,1px)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 66v-1.991L.68 64l-.116.009c-.439.076-.55.618-.565.92l-.001.07.006.151c.026.31.143.771.556.841L.672 66H10z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 0v1.991L.68 2l-.116-.009c-.439-.076-.55-.618-.565-.92L-.002 1 .004.85C.03.54.147.079.56.009L.672 0H10z",
    style: {
      transform: "translate(-2px,-1px)"
    }
  }));
};

Loader.defaultProps = {
  viewBox: "0 0 78 64",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "1.5"
};

var position = function position(full) {
  if (full) {
    return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      min-height: 100vh;\n      position: fixed;\n    "])));
  } else {
    return (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      position: absolute;\n    "])));
  }
};

var SpinnerStyled = (0, _utils.styled)('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  &::after {\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    content: '';\n    display: inline-block;\n    z-index: 51;\n    width: 28px;\n    height: 28px;\n    font-size: 28px;\n    line-height: 28px;\n    border: 2px solid ", ";\n    border-top: 2px solid ", ";\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), _const.Colors.white, function (_ref) {
  var $color = _ref.$color;
  return _const.Colors[$color];
});
exports.SpinnerStyled = SpinnerStyled;
var LoadingStyled = (0, _utils.styled)('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  z-index: 20;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: ", ";\n  ", ";\n\n  > div {\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    text-align: center;\n  }\n\n  span {\n    display: block;\n    margin-top: 15px;\n    font-size: ", ";\n    color: ", ";\n  }\n\n  path {\n    stroke: ", ";\n  }\n"])), function (_ref2) {
  var bg = _ref2.bg;
  return _const2.LoadingBg[bg];
}, function (_ref3) {
  var full = _ref3.full;
  return position(full);
}, function (_ref4) {
  var $fontSize = _ref4.$fontSize;
  return "".concat($fontSize, "px");
}, function (_ref5) {
  var $color = _ref5.$color;
  return _const.Colors[$color];
}, function (_ref6) {
  var $color = _ref6.$color;
  return _const.Colors[$color];
});
exports.LoadingStyled = LoadingStyled;
var LogoStyled = (0, _utils.styled)(Loader)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 63.4px;\n  width: 77px;\n\n  path {\n    fill: none;\n    stroke-width: 2px;\n    stroke-dasharray: 200;\n    stroke-dashoffset: 200;\n    animation: dash 2s linear infinite alternate;\n\n    &:nth-of-type(3) {\n      animation-name: dash1;\n      stroke-width: 4px;\n    }\n\n    &:nth-of-type(4) {\n      animation-name: dash2;\n    }\n  }\n\n  @keyframes dash {\n    0% {\n      stroke-dashoffset: 200;\n    }\n    100% {\n      stroke-dashoffset: 0;\n    }\n  }\n\n  @keyframes dash1 {\n    0% {\n      stroke-dashoffset: 200;\n    }\n    43% {\n      stroke-dashoffset: 200;\n    }\n    100% {\n      stroke-dashoffset: 0;\n    }\n  }\n\n  @keyframes dash2 {\n    0% {\n      stroke-dashoffset: 200;\n    }\n    75% {\n      stroke-dashoffset: 200;\n    }\n    100% {\n      stroke-dashoffset: 0;\n    }\n  }\n"])));
exports.LogoStyled = LogoStyled;